import {Link, useLocation} from "react-router-dom";

export const HomeHeader = (props: { signup: boolean }) => {
    const location = useLocation();
    return (
        <>
            <div className="welcome-header">
                <div className="container-big">
                    <div>
                        <Link to="/" className="welcome-header-logo"
                              onClick={() => window.scrollTo({top: 0, behavior: "smooth"})}>
                            <i style={{backgroundImage: `url(/logo.png)`}}/>
                            <b className="d-md-inline-block d-none">دبستان هوشمند نهال</b>
                            <b className="d-md-none">نهال</b>
                        </Link>
                        <div className="welcome-header-buttons">
                            {
                                props.signup && location.pathname !== '/signup' ?
                                    <Link to="/signup" className="welcome-header-sec">
                                        <span>پیش ثبت‌نام</span>
                                    </Link> : null
                            }
                            {
                                location.pathname !== '/signup' ?
                                    <Link to="/students/overview" className="welcome-header-cta">
                                        <span>ورود دانش‌آموز</span>
                                    </Link> : null
                            }
                        </div>
                    </div>
                </div>
                <div className="welcome-header-under">
                    <div className="container-big">
                        <div>
                            <Link to={"/news"}>
                                <span>اطلاعیه ها</span>
                            </Link>
                            <Link to={"/gallery"}>
                                <span>گالری</span>
                            </Link>
                            <Link to={"/bank"}>
                                <span>بانک نهال</span>
                            </Link>
                            <Link to={"/reports"}>
                                <span>گزارشات کلاسی</span>
                            </Link>
                            <Link to={"/honors"}>
                                <span>افتخارات</span>
                            </Link>
                            <Link to={"/about"}>
                                <span>درباره نهال</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};